import { Component, Input } from '@angular/core';

import { EventType } from '../../../../../../models/event-type';
import { ScheduleType } from '../../../../../../models/event-type-enums';


@Component({
  selector: 'app-event-setup-nav',
  templateUrl: './event-setup-nav.component.html',
  styleUrls: ['./event-setup-nav.component.css']
})
export class EventSetupNavComponent {
  @Input() eventType: EventType;
  @Input() loadingEventType: boolean;

  public readonly ScheduleType = ScheduleType;
}
